import { Routes } from '@angular/router';

import { PageNotFoundComponent } from '@layout/page-not-found/page-not-found.component';
import { UnauthorisedComponent } from '@layout/unauthorised/unauthorised.component';
import { HomeComponent } from '@layout/home/home.component';
import { LegalDocsComponent } from './modules/legaldocs/legal-docs/legal-docs.component';
import { DefaultTemplateComponent } from './modules/layout/default-template/default-template.component';
import { ExternalTemplateComponent } from './modules/layout/external-template/external-template.component';

export const routes: Routes = [
  {
    path: '',
    component: DefaultTemplateComponent,
    data: { reuseRoute: true },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
        data: { reuseRoute: true },
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { reuseRoute: true },
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.routes').then((r) => r.routes),
        data: { reuseRoute: false },
      },
      {
        path: 'therapist',
        loadChildren: () => import('./modules/therapist/therapist.routes').then((r) => r.routes),
        data: { reuseRoute: true },
      },
      {
        path: 'authentication',
        loadChildren: () => import('./modules/authentication/authentication.routes').then((r) => r.routes),
        data: { reuseRoute: false },
      },
      {
        path: 'account',
        loadChildren: () => import('./modules/account/account.routes').then((r) => r.routes),
        data: { reuseRoute: false },
      },
      {
        path: 'callback',
        loadChildren: () => import('./modules/callback/callback.routes').then((r) => r.routes),
        data: { reuseRoute: false },
      },
      {
        path: 'unauthorised',
        component: UnauthorisedComponent,
        data: { reuseRoute: false },
      },
    ],
  },
  {
    path: '',
    component: ExternalTemplateComponent,
    data: { reuseRoute: true },
    children: [
      {
        path: 'transactional',
        loadChildren: () => import('./modules/transactional/transactional.routes').then((r) => r.routes),
        data: { reuseRoute: false },
      },
      {
        path: 'legal/:doc',
        component: LegalDocsComponent,
        data: { reuseRoute: false },
      },
      {
        path: '**',
        component: PageNotFoundComponent,
        data: { reuseRoute: false },
      },
    ],
  },
];
